import makeStyles from "e100-react-components/lib/styles/makeStyles";

const useStyles = makeStyles(({ spacing }) => ({
  container: {
    padding: spacing(2),
    "& button": {
      marginRight: spacing(1),
    },
  },
}));

export default useStyles;
